/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Calendar,
  Badge,
  Typography,
  Form,
  Select,
  Spin,
  Table,
  notification,
} from 'antd';
import { Button as CrceButton } from '@crc-evans/ui-components';
import { X } from 'lucide-react';
import moment from 'moment';
import LogDetailsTable from './LogDetailsTable';
import { getPopupContainerBody } from './ShippingManagement/shipmentFieldOptions';
import './ShippingManagement/ShipmentDashBoardPage.css';
import '../pages/dashboard/DashboardPage.css';
import './LogDetails.css';

const { Text } = Typography;
const { Option } = Select;

const SELECT_DROPDOWN = 'modern-dropdown-popup mc-dpr-modal-select-dd';

const LogCalender = (props) => {
  const {
    locationData,
    dataList,
    columnList,
    showLogLoader,
    setPipeline,
    pipeline,
    setYearData,
    yearData,
    setMonthData,
    monthData,
    setSelectedPipeline,
    selectedPipeline,
    calenderForm,
    getCalData,
    calenderList,
    isCalenderLoading,

    onFetchLogDetails,
    setDataList,
    totalCount,
    calenderView,
    setCalenderView,
    calenderClass,
    setCalenderClass,
    isWriteAccess,
  } = props;

  const [loading, setLoading] = useState(false);
  const [logPopup, setLogPopup] = useState(false);
  const [tableDated, settableDated] = useState(false);

  useEffect(() => {
    if (pipeline && calenderList && calenderList.length > 0) {
      setCalenderView(true);
      setCalenderClass('view');
    } else {
      setCalenderView(false);
      setCalenderClass('hide');
    }
  }, [calenderList]);

  const getListData = (value) => {
    let listData = [];
    switch (moment(value).format('YYYY-MM-DD')) {
      case moment(value).format('YYYY-MM-DD'):
        for (let i = 0; i < calenderList.length; i++) {
          if (calenderList[i].date == moment(value).format('YYYY-MM-DD')) {
            listData.push(calenderList[i]);
          }
        }
        break;

      default:
    }

    return listData || [];
  };

  const getMonthData = (value) => {
    let listData = [];
    let num = 0;
    switch (moment(value).format('YYYY-MM')) {
      case moment(value).format('YYYY-MM'):
        for (let i = 0; i < calenderList.length; i++) {
          if (moment(calenderList[i].date).format('YYYY-MM') == moment(value).format('YYYY-MM')) {
            var obj = {
              date: moment(calenderList[i].date).format('YYYY-MM'),
              totalWelds: calenderList[i].totalWelds,
            };
            listData.push(obj);
          }
        }
        if (listData.length > 0) {
          for (var i = 0; i < listData.length; i++) {
            num += listData[i].totalWelds;
          }
        }

        break;

      default:
    }
    return num;
  };

  const monthCellRender = (value) => {
    const num = getMonthData(value);
    return num ? (
      <div
        className="notes-month"
        style={{ background: num <= 100 ? 'green' : num <= 200 ? 'orange' : '' }}
      >
        <section>Total No. of Welds: {num}</section>
      </div>
    ) : null;
  };

  const dateCellRender = (value) => {
    const listData = getListData(value);
    return (
      <>
        {listData.map((item) => (
          <div
            onClick={(e) => handleLogChange(item)}
            className="events"
            key={item.totalWelds}
            style={{
              background: item.totalWelds <= 100 ? 'green' : item.totalWelds <= 200 ? 'orange' : '',
            }}
          >
            <Text>No. of Welds: {item.totalWelds}</Text>
          </div>
        ))}
      </>
    );
  };

  const handleLogChange = (item) => {
    if (item && selectedPipeline) {
      var obj = {
        fromDate: item.date,
        toDate: item.date,
        sowId: selectedPipeline.id,
        pageSize: 20,
        pageIndex: 0,
      };
      sessionStorage.setItem(
        'page',
        JSON.stringify({
          pageSize: 20,
          pageIndex: 0,
        })
      );
      onFetchLogDetails(obj);
      setLogPopup(true);
      settableDated(obj);
    } else {
      notification.warning({
        message: 'Select Pipeline to Proceed!',
      });
    }
  };

  const handlePipelineChange = (value) => {
    setPipeline(value);
    if (locationData.length > 0) {
      const locData = locationData.find((u) => u.pipelineSection === value);
      setSelectedPipeline(locData);
    }
  };

  const handleCancel = () => {
    setLogPopup(false);
    setDataList([]);
  };

  const handleCalederChange = () => {
    calenderForm.validateFields().then((data) => {
      if (data.pipeline && data.month + 1 && data.year) {
        var obj = {
          sowId: selectedPipeline.id,
          month: monthData,
          year: yearData,
        };
        getCalData(obj);
      } else if (!data.pipeline && !data.month + 1 && !data.year) {
        notification.warning({
          message: 'Select Pipeline, Year and Month to proceed!',
        });
      } else if (!data.pipeline) {
        notification.warning({
          message: 'Select Pipeline to proceed!',
        });
      } else if (!data.year) {
        notification.warning({
          message: 'Select Year to proceed!',
        });
      } else if (!data.month) {
        notification.warning({
          message: 'Select Month to proceed!',
        });
      }
    });
  };

  return (
    <div className="log-calender-root">
      <Spin
        spinning={isCalenderLoading}
        tip="Loading..."
        size="medium"
      >
        <div
          className={`log-calender ${calenderClass}${
            !calenderView && !isCalenderLoading ? ' log-calender--empty-state' : ''
          }`}
        >
          <Calendar
            dateCellRender={dateCellRender}
            monthCellRender={monthCellRender}
            locale={moment.locale('en', {
              week: {
                dow: 1,
              },
              weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            })}
            headerRender={({ value, type, onChange }) => {
              const start = 0;
              const end = 12;
              const monthOptions = [];
              const current = value.clone();
              const localeData = value.localeData();
              const months = [];

              for (let i = 0; i < 12; i++) {
                current.month(i);
                months.push(localeData.monthsShort(current));
              }

              for (let i = start; i < end; i++) {
                monthOptions.push(
                  <Select.Option
                    key={i}
                    value={i}
                    className="month-item"
                  >
                    {months[i]}
                  </Select.Option>
                );
              }

              const year = value.year();
              const month = value.month();
              const options = [];

              for (let i = year - 5; i < year + 15; i += 1) {
                options.push(
                  <Select.Option
                    key={i}
                    value={i}
                    className="year-item"
                  >
                    {i}
                  </Select.Option>
                );
              }

              return (
                <div className="calender_header">
                  <Form
                    form={calenderForm}
                    name="basic"
                    layout="vertical"
                    autoComplete="off"
                  >
                    <div className="log-calendar-filter-row">
                      <div className="log-calendar-filter-field log-calendar-filter-field--pipeline">
                        <Form.Item
                          name="pipeline"
                          label="Pipeline"
                          required
                          style={{ marginBottom: 0 }}
                          className="log-calendar-filter-form-item"
                        >
                          <Select
                            className="log-calendar-filter-select log-filter-select log-filter-select--pipeline"
                            placeholder="Choose pipeline section…"
                            dropdownClassName={SELECT_DROPDOWN}
                            getPopupContainer={getPopupContainerBody}
                            onChange={(v) => handlePipelineChange(v)}
                            value={pipeline === '' || pipeline == null ? undefined : pipeline}
                            allowClear
                          >
                            {locationData &&
                              locationData.map((item, i) => (
                                <Option
                                  key={i}
                                  value={item && item.pipelineSection}
                                >
                                  {item?.pipelineSection}{' '}
                                  {item?.pipeStringId && `(${item?.pipeStringId})`}
                                </Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="log-calendar-filter-field log-calendar-filter-field--year">
                        <Form.Item
                          name="year"
                          label="Year"
                          style={{ marginBottom: 0 }}
                          className="log-calendar-filter-form-item"
                        >
                          <Select
                            size="small"
                            placeholder="Year"
                            dropdownMatchSelectWidth={false}
                            dropdownClassName={SELECT_DROPDOWN}
                            getPopupContainer={getPopupContainerBody}
                            className="log-calendar-filter-select year log-filter-select log-filter-select--ym"
                            value={year}
                            onChange={(newYear) => {
                              const now = value.clone().year(newYear);
                              onChange(now);
                              setYearData(moment(now).format('YYYY'));
                            }}
                          >
                            {options}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="log-calendar-filter-field log-calendar-filter-field--month">
                        <Form.Item
                          name="month"
                          label="Month"
                          style={{ marginBottom: 0 }}
                          className="log-calendar-filter-form-item"
                        >
                          <Select
                            size="small"
                            className="log-calendar-filter-select month log-filter-select log-filter-select--ym"
                            placeholder="Month"
                            dropdownMatchSelectWidth={false}
                            dropdownClassName={SELECT_DROPDOWN}
                            getPopupContainer={getPopupContainerBody}
                            value={month}
                            onChange={(newMonth) => {
                              const now = value.clone().month(newMonth);
                              onChange(now);
                              setMonthData(moment(now).format('MM'));
                            }}
                          >
                            {monthOptions}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="log-calendar-filter-apply">
                        <CrceButton
                          label="Apply"
                          variant="primary"
                          size="small"
                          onClick={() => {
                            if (!isWriteAccess) handleCalederChange();
                          }}
                          disabled={isWriteAccess}
                        />
                      </div>
                    </div>
                  </Form>
                </div>
              );
            }}
          />
          {!calenderView && !isCalenderLoading && (
            <Table
              className="log-calendar-empty-table"
              pagination={false}
            />
          )}
        </div>
      </Spin>
      {logPopup && (
        <div
          className="mc-dpr-modal-backdrop"
          role="presentation"
          onClick={(e) => {
            if (e.target === e.currentTarget) handleCancel();
          }}
        >
          <div
            className="mc-dpr-modal mc-dpr-modal--log-details"
            role="dialog"
            aria-labelledby="log-details-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mc-dpr-modal-head">
              <h3 id="log-details-modal-title" className="mc-dpr-modal-title">
                Logs
              </h3>
              <button
                type="button"
                className="mc-dpr-modal-close"
                aria-label="Close"
                onClick={handleCancel}
              >
                <X size={20} />
              </button>
            </div>
            <div className="mc-dpr-modal-body">
              <LogDetailsTable
                dataList={dataList}
                showLogLoader={showLogLoader}
                columnList={columnList}
                tableDated={tableDated}
                onFetchLogDetails={onFetchLogDetails}
                totalCount={totalCount}
              />
            </div>
            <div className="mc-dpr-modal-foot">
              <CrceButton
                label="Close"
                variant="tertiary"
                size="medium"
                onClick={handleCancel}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogCalender;
